import React from 'react';
import PropTypes from 'prop-types';

const RocketIcon = ({ className, color = '#006E66' }) => {
  return (
    <svg
      className={className}
      fill="none"
      height="42"
      viewBox="0 0 42 42"
      width="42"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5 26.25C9.0475 26.25 7.735 26.845 6.79 27.79C4.725 29.855 3.5 38.5 3.5 38.5C3.5 38.5 12.145 37.275 14.21 35.21C15.155 34.265 15.75 32.9525 15.75 31.5C15.75 28.595 13.405 26.25 10.5 26.25ZM11.7425 32.7425C11.2525 33.2325 7.945 34.0725 7.945 34.0725C7.945 34.0725 8.7675 30.7825 9.275 30.275C9.5725 29.9425 10.01 29.75 10.5 29.75C11.4625 29.75 12.25 30.5375 12.25 31.5C12.25 31.99 12.0575 32.4275 11.7425 32.7425ZM30.485 23.8875C41.615 12.7575 37.905 4.095 37.905 4.095C37.905 4.095 29.2425 0.385004 18.1125 11.515L13.755 10.64C12.6175 10.4125 11.4275 10.78 10.5875 11.6025L3.5 18.7075L12.25 22.4525L19.5475 29.75L23.2925 38.5L30.38 31.4125C31.2025 30.59 31.57 29.4 31.3425 28.245L30.485 23.8875ZM12.9675 18.9525L9.625 17.5175L13.0725 14.07L15.5925 14.5775C14.595 16.03 13.7025 17.5525 12.9675 18.9525ZM24.4825 32.375L23.0475 29.0325C24.4475 28.2975 25.97 27.405 27.405 26.4075L27.9125 28.9275L24.4825 32.375ZM28 21.42C25.69 23.73 22.085 25.62 20.93 26.1975L15.8025 21.07C16.3625 19.9325 18.2525 16.3275 20.58 14C28.77 5.81 34.9825 7.0175 34.9825 7.0175C34.9825 7.0175 36.19 13.23 28 21.42ZM26.25 19.25C28.175 19.25 29.75 17.675 29.75 15.75C29.75 13.825 28.175 12.25 26.25 12.25C24.325 12.25 22.75 13.825 22.75 15.75C22.75 17.675 24.325 19.25 26.25 19.25Z"
        fill={color}
      />
    </svg>
  );
};

RocketIcon.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
};

export default RocketIcon;

